export const BASE_IMAGE_URL = 'https://a.1stdibscdn.com/dist/adhoc/trade/benefits';

export const NET_PRICE_PERCENTAGE = 30;

export const TRADE_SALES_EMAIL = 'team.clientpartner@1stdibs.com';

export const CUSTOMER_SUPPORT_URL = '/contact/';

export const UNASSIGNED_REP_EMAIL = 'trade@1stdibs.com';

export const CURRENT_TIER_SECTION_ID = 'trade-benefits-current-tier';

export const PURCHASE_PROTECTION_SECTION_ID = 'trade-benefits-purchase-protection';

export const TRADE_STATUS = {
    BRONZE: 'BRONZE',
    SILVER: 'SILVER',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM',
} as const;

export type TradeStatusCode = (typeof TRADE_STATUS)[keyof typeof TRADE_STATUS];

export const SILVER_PLUS_CODES: ReadonlySet<TradeStatusCode> = new Set([
    TRADE_STATUS.SILVER,
    TRADE_STATUS.GOLD,
    TRADE_STATUS.PLATINUM,
]);
